module.exports = __webpack_public_path__ + "img/mon_256.19f443ee.png";